import { render } from "./RappresentantiDataTable.vue?vue&type=template&id=099009fc&scoped=true"
import script from "./RappresentantiDataTable.vue?vue&type=script&lang=js"
export * from "./RappresentantiDataTable.vue?vue&type=script&lang=js"

import "./RappresentantiDataTable.vue?vue&type=style&index=0&id=099009fc&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099009fc"]])

export default __exports__